<div class="rt-split">
  <app-auth-brand-panel></app-auth-brand-panel>
  <div class="rt-login-col">
    <div class="rt-login-form">
      <div *ngIf="isLoading" class="rt-overlay">
        <div class="rt-spinner"></div>
      </div>

      <h2 class="rt-title">{{ 'compliance.change_password.change_password' | translate }}</h2>
      <p class="rt-subhead">{{ 'compliance.change_password.choose_strong_password' | translate }}</p>

      <form #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">
        <div class="rt-field rt-field-password">
          <ejs-textbox class="rt-input" [(ngModel)]="newPassword" name="newPassword"
            [type]="newPasskey ? 'text' : 'password'" [placeholder]="'compliance.change_password.new_password' | translate"
            required></ejs-textbox>
          <img class="rt-toggle" [class.rt-toggle-on]="newPasskey" src="assets/vectors/password-visibility.svg"
            [alt]="(newPasskey ? 'app.login.hide_password' : 'app.login.show_password') | translate"
            [title]="(newPasskey ? 'app.login.hide_password' : 'app.login.show_password') | translate"
            (click)="newPasskey = !newPasskey" />
        </div>

        <div class="rt-field rt-field-password">
          <ejs-textbox class="rt-input" [(ngModel)]="confirmPassword" name="confirmPassword"
            [type]="confirmPasskey ? 'text' : 'password'" [placeholder]="'compliance.change_password.confirm_new_password' | translate"
            required></ejs-textbox>
          <img class="rt-toggle" [class.rt-toggle-on]="confirmPasskey" src="assets/vectors/password-visibility.svg"
            [alt]="(confirmPasskey ? 'app.login.hide_password' : 'app.login.show_password') | translate"
            [title]="(confirmPasskey ? 'app.login.hide_password' : 'app.login.show_password') | translate"
            (click)="confirmPasskey = !confirmPasskey" />
        </div>

        <div *ngIf="submitted && validationErrorMessage" class="rt-validation">{{ validationErrorMessage }}</div>
        <div *ngIf="apiErrorMessage" class="rt-validation">{{ apiErrorMessage }}</div>

        <div class="rt-btn-row">
          <button ejs-button type="submit" class="rt-btn-primary">{{ 'compliance.change_password.submit' | translate }}</button>
          <button ejs-button type="button" class="rt-btn-secondary" (click)="clearForm()">{{ 'compliance.change_password.clear' | translate }}</button>
        </div>
      </form>

      <div class="rt-backlink" (click)="closePopup()">
        <span class="rt-link">{{ 'compliance.change_password.click_here_to_go_back' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<app-alert-popup [Data]="alertData" (confirm)="onAlertConfirm()" (close)="onAlertClose()"></app-alert-popup>
